<template>
    <div class="chart-inner" ref="numberChart">
    </div>
</template>

<script>
  /* eslint-disable */
  import * as d3 from 'd3'

  export default {
    props: {
      numberVal: {type: Number},
      colorOverride: {type: String},
      trend: [Array, Object],
      presenterView: Boolean
    },
    data() {
      return {
        progress: 100
      }
    },
    watch: {
      numberVal(newVal) {
        this.$refs.numberChart.innerHTML = ''
        this.draw()
      }
    },
    mounted() {
      this.draw()
    },

    methods: {
      draw() {
        const tau = 2 * Math.PI;
        const element = this.$el
        const width = 550
        const height = 400
        const radius = width / 2
        const viewBox = `0 0 ${width} ${height}`
        const fontSize = this.presenterView ? 180 : this.numberVal < 1000 ? width / 4.2 : width / 5;

        const arc = d3.arc()
          .innerRadius(radius - 91)
          .outerRadius(radius - 110)
          .startAngle(0);

        const arcInner = d3.arc()
          .innerRadius(radius - 22)
          .outerRadius(radius - 38)
          .startAngle(0);

        const svg = d3.select(element)
          .append('svg')
          .attr('viewBox', viewBox)

        const g = svg.append("g")
          .attr('transform', `translate(${width / 2}, ${this.presenterView ? height /2 + 20 : height / 2})`)

        let text = g.append("text")
          .text('0')
          .attr("class", "percentage-text")
          .attr("text-anchor", "middle")
          .style("font-size",fontSize+'px')
          .style("font-weight", 'normal')
          .attr("dy", (height / 10) + 5)

        ////////////////////////////////////////////////
        const background = g.append("path")
          .datum({endAngle: 0})
          .style("fill", "#ddd")
          .attr("d", arcInner)
          .transition()
          .delay(200)
          .duration(800)
          .ease(d3.easeCubicIn)
          .attrTween("d", arcTween(tau));

        let foreground = null
        if (this.colorOverride) {
          foreground = g.append("path")
            .datum({endAngle: 0})
            .attr("d", arc)
            .attr('fill', this.colorOverride)
            .transition()
            .delay(1050)
            .duration(1500)
            .ease(d3.easeCubicOut);
        } else {
          foreground = g.append("path")
            .datum({endAngle: 0})
            .attr("d", arc)
            .attr('class', 'color-ring')
            .transition()
            .delay(1050)
            .duration(1500)
            .ease(d3.easeCubicOut);
        }

        foreground.attrTween("d", arcTween(tau));

        function arcTween(newAngle) {
          return function(d) {
            var interpolate = d3.interpolate(d.endAngle, newAngle);
            return function(t) {
              d.endAngle = interpolate(t);
              return arc(d);
            };
          };
        }
        ////////////////////////////////////////////////

        var format = d3.format(",d");

        const tweenElement = this.$refs.numberChart
        const maxValue = this.numberVal
        const numberAnimate = d3.select(tweenElement)
          .transition()
            .duration(2500)
            .on("start", function repeat() {
              d3.active(this)
                  .tween("text", function() {
                    var that = d3.select(this)
                    var i = d3.interpolateNumber(text.text().replace(/,/g, ""), maxValue);
                    return function(t) { text.text(format(i(t))); };
                  })
                .transition()
                  .delay(1500)
                  .on("start", repeat);
            });
        if(this.trend){
          function getMaxValue(dataset, key) {
            const array = dataset.reduce((a, b) => a.concat(b))
            const max = array.reduce((a, b) => (a[key] > b[key]) ? a : b)

            return max[key];
          }
          const dataset = [
            [ {x: 1, y: Math.floor(Math.random() * 100)},
              {x: 2, y: this.numberVal}
            ]
          ]
          const options = {
            margin : { top: 0, right: 0, bottom: 0,left: 0 },
            height: 0,
            width: 300,
            colors: ['#64B1D6', '#80BB41'],
          }
          const margin = {
              top: options.margin.top || 0,
              right: options.margin.right || 0,
              bottom: options.margin.bottom || 0,
              left: options.margin.left || 0
            },
            width2 = options.width - margin.left - margin.right,
            height2 = options.height - margin.top - margin.bottom;

          let randomNumber = Math.floor(Math.random() * 10000000)
          var colorRange = ['#d7191c', '#fdae61', '#ffffbf', '#a6d96a', '#1a9641'];

          const xScale = d3.scaleLinear()
            .domain([0, getMaxValue(dataset, 'x')])
            .range([0, 60])

          const yScale = d3.scaleLinear()
            .domain([0, getMaxValue(dataset, 'y')])
            .range([25, 0])
          
          const g2 = svg.append("g")
            .attr("transform", "translate(260,299)");

          const line = d3.line()
            .x((d, i) => xScale(i))
            .y((d, i) => yScale(d.y))


          function pickColor(value) {
              if(value <= 25) {
                return '#C60E2B'
              } else if(value <= 40) {
                return '#F27830'
              } else if(value <= 55) {
                return '#FFD167'
              } else if(value <= 80) {
                return '#8BC34A'
              } else {
                return '#21931B'
              }
          }
          dataset.forEach((set, index) => {
            var linearGradient = g2.append("defs")
              .append("linearGradient")
              .attr("id", `linear-gradient${randomNumber}`);

            linearGradient.append("stop")
              .attr("offset", "30%")
              .attr("stop-color", pickColor(set[0].y));

            linearGradient.append("stop")
              .attr("offset", "70%")
              .attr("stop-color", pickColor(set[1].y));

            g2.append('path')
              .datum(set)
              .attr('class', 'line')
              .attr('d', line)
              .attr("stroke", `url(#linear-gradient${randomNumber})`)
              .attr("fill", "none");

            g2.selectAll('.dot' + index)
              .data(set)
              .enter().append('circle')
              .attr('class', 'dot')
              .attr('cx', (d, i) => xScale(i))
              .attr('cy', (d, i) => yScale(d.y))
              .attr('r', 6)
              .attr("stroke", (d, i) => pickColor(d.y))
              .attr('fill', '#fff')

          });
        }
      }
    }
  }
  /* eslint-enable */
</script>

<style lang="sass">
  @import '../../../styles/helpers/_mixins.sass'
  @import '../../../styles/base/variables'


  .chart-inner
    cursor: pointer
          
  .percentage-text
    fill: $color-body-bg

  .color-ring
    fill: $color-body-bg

  .color-default
    fill: $color-body-bg

  .line
    stroke-width: 6

  .dot 
    transition: all .05s ease-in-out
    stroke-width: 6
  
</style>



// WEBPACK FOOTER //
// ../raypro_ui/src/components/ui/charts/NumberChart.vue